import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource
} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { LaravelResourceResponse } from '../../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../../_base-shared/models/Case/Case';
import { PaymentMethod, PaymentMethodType } from '../../../../../../../../_base-shared/models/Payment/PaymentMethod';
import { PaymentProcessorType } from '../../../../../../../../_base-shared/models/Payment/PaymentProcessor';
import { PaymentTerm } from '../../../../../../../../_base-shared/models/Payment/PaymentTerm';
import { PaymentPlanType } from '../../../../../../../../_base-shared/models/Product/PaymentPlanType';
import { User } from '../../../../../../../../_base-shared/models/User/User';
import { environment } from '../../../../../../environments/environment';
import {
  RequestPaymentModalComponent,
} from '../../../../../_shared/components/request-payment-modal/request-payment-modal.component';
import { MainGlobalEventService } from '../../../../../_shared/services/main-global-event.service';
import { DistributionService } from '../../../../distribution/distribution.service';
import {
  AdminPaymentHandlerComponent
} from '../../../../payment/admin-payment-handler/admin-payment-handler.component';
import { PaymentMethodService } from '../../../../payment/payment-method.service';
import { PaymentPlanTypeService } from '../../../../payment/payment-plan-type.service';
import { PaymentService } from '../../../../payment/payment.service';
import { CaseDocumentService } from '../../../case-document.service';
import {
  CasePaymentPlanGeneratorComponent,
} from '../case-payment-plan-generator/case-payment-plan-generator.component';
import { RebuildPaymentPlanComponent } from '../rebuild-payment-plan/rebuild-payment-plan.component';
import { RecordPaymentModalComponent } from './record-payment-modal/record-payment-modal.component';
import { saveAs } from 'file-saver';
import { TransferFeesComponent } from './transfer-fees-modal/transfer-fees.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RebuildPaymentPlanV2Component } from '../rebuild-payment-plan-v2/rebuild-payment-plan-v2.component';
import { AppSelectOption } from '../../../../../../../../_base-shared/contracts/common.interface';
import { UpcomingInstallmentListComponent } from './upcoming-installment-list/upcoming-installment-list.component';

@Component({
  standalone: false,
  selector:    'app-case-installment-list',
  templateUrl: './case-installment-list.component.html',
  styleUrls:   ['./case-installment-list.component.scss'],
  animations:  [
    trigger('detailExpandDS', [
      state('collapsed', style({display: 'none', minHeight: '0'})),
      state('expanded', style({display: 'block'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpand', [
      state('collapsed', style({display: 'none', minHeight: '0'})),
      state('expanded', style({display: 'block'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CaseInstallmentListComponent implements OnInit {
  @Input() componentType: 'distribution' | 'admin';
  @Input() case: Case;
  @Input() openRecordPaymentDialog: EventEmitter<any>;
  @Output() paymentRecorded: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('changeValueModal') valueModal: ElementRef;
  @ViewChild(UpcomingInstallmentListComponent) upcomingInstallmentsComponent: UpcomingInstallmentListComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public appEnv: string;
  public upcomingInstallments: Array<PaymentTerm> = [];
  public unpaidInstallments                       = [];

  public installmentsPlanTypeSlugsControl  = new UntypedFormControl(['debt_plan'], [Validators.required]);
  public installmentsPlanTypeGroupsControl = new UntypedFormControl(['debt_plan'], [Validators.required]);

  public totalResults: number;

  public filteredInstallmentsBalance        = {
    totalPaid:        0,
    totalToPay:       0,
    totalPaidCounter: 0,
    totalDistributed: 0,
  };
  public debtPlanInstallmentsBalance        = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public additionalPlansInstallmentsBalance = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public paginatorConfig                    = {
    pageIndex: 0,
    pageSize:  10,
    length:    1,
  };
  public now                                = new Date(new Date().setHours(0, 0, 0, 0));
  public isLoading                          = 0;
  public authUser: User;
  public paymentMethods: Array<PaymentMethod>;
  public paymentPlanTypes: Array<PaymentPlanType>;
  public paymentPlanTypeGroups: Array<AppSelectOption>;
  private forceDefaultProcessor             = false;
  public selectionPayments                  = new SelectionModel<any>(true, []);
  public selectionPaymentsDisabled          = true;
  public onlyDebtPlanSelected               = true;
  public isSubmitting: boolean;

  public templateData: Array<any>    = [];
  public creditorsMerged: Array<any> = [];

  public authorizedUsers       = [1, 27, 751562, 751600, 752733];
  public allowedFundsTransfer  = [1, 27, 752900, 751600, 36, 751562];
  public installmentListActive = true;

  public managementFeeInstallments: Array<PaymentTerm>;
  public negotiationFeeInstallments: Array<PaymentTerm>;
  public debtPlanFeeInstallments: Array<PaymentTerm>;
  public settlementBalance: number;
  public totalAmountPaidDebtPlan: number;
  public managementBalance: number;
  public totalAmountPaidManagement: number;
  public totalDebtAmountManagement: number;
  public negotiationBalance: number;
  public totalAmountPaidNegotiation: number;
  public totalDebtAmountNegotiation: number;
  private dataSource: MatTableDataSource<PaymentTerm>;
  private sortOrder = null;
  private sortBy    = null;
  public isLocalOrStagingEnvironment = environment.APP_ENV === 'local' || environment.APP_ENV === 'staging';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private translate: TranslateService,
    private globalEventsService: MainGlobalEventService,
    private paymentService: PaymentService,
    private distributionService: DistributionService,
    private paymentMethodService: PaymentMethodService,
    private paymentPlanTypeService: PaymentPlanTypeService,
    private caseDocumentService: CaseDocumentService
  ) {
    this.appEnv = environment.APP_ENV;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(result => {
      const stateParams    = new URLSearchParams(result);
      const paymentOutcome = stateParams.get('payment_outcome');
      if (paymentOutcome === 'success' || paymentOutcome === 'error' || paymentOutcome === 'cancelled') {
        const paymentSuccess = paymentOutcome === 'success';
        let title: string;
        let message: string;
        if (paymentOutcome === 'success') {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.success.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.success.message');
        } else if (paymentOutcome === 'cancelled') {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.cancelled.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.cancelled.message');
        } else {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.error.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.error.message');
        }
        Swal.fire({
          title,
          text:               message,
          icon:               paymentSuccess ? 'success' : 'error',
          showCancelButton:   false,
          showConfirmButton:  true,
          cancelButtonText:   this.translate.instant('SHARED.cancel'),
          confirmButtonColor: '#886ab5',
        }).then(res => {
          if (res.isConfirmed) {
            this.router.navigate([], {queryParams: {payment_outcome: null}, queryParamsHandling: 'merge'});
          }
        });

      }
    });
    this.globalEventsService.authUser$.subscribe(user => {
      this.authUser = user;
      this.fetchInstallments(this.componentType);
      this.fetchPaymentPlanTypes(this.componentType);
      this.paymentPlanTypeGroups = this.getPaymentPlanTypeGroups();
      //  Get total amount of paid terms and total amount to pay
      this.case.terms.forEach(term => {
        this.filteredInstallmentsBalance.totalToPay += term.amount;
        this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
        this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;
        if (term.case_plan_id === this.case.debt_payment_plan.id) {
          this.debtPlanInstallmentsBalance.totalToPay += term.amount;
          this.debtPlanInstallmentsBalance.totalPaid += term.amount_paid;
        }
        if (term.case_plan_id !== this.case.debt_payment_plan.id) {
          this.additionalPlansInstallmentsBalance.totalToPay += term.amount;
          this.additionalPlansInstallmentsBalance.totalPaid += term.amount_paid;
        }
      });
    });

    this.selectionPayments.changed.subscribe(next => {
      this.checkIfDisabled(next);
    });

    //better to calculate if phase1 or 2 using variables than calling from the template
    //this.monthsRemaining = this.getMonthsRemaining();
    this.templateData.push(this.viewCalculations());

    let creditors     = this.case.unsecured_creditors
    //const cred_unifye = this.case.creditors.find(creditor => creditor.id === 2817);
    const cred_unifye = this.case.creditors.find(creditor => creditor.name === 'UNIFYE');
    if (cred_unifye) {
      creditors.push(cred_unifye);
    }
    //not grouping for now, delete it ?  DAM
    //this.creditorsMerged = this.groupByNameAndCollectValues(creditors);
    this.creditorsMerged = creditors
    //console.log(this.creditorsMerged);
    if (this.case) {
      this.fetchInstallmentFees('negotiation_fee');
      this.fetchInstallmentFees('management_fee');
      this.fetchInstallmentFees('debt_plan_fee');
    }

    this.installmentsPlanTypeGroupsControl.valueChanges.subscribe(value => {
      this.planTypeGroupsUpdated(value);
    });

    this.installmentsPlanTypeSlugsControl.valueChanges.subscribe(value => {
      this.fetchInstallments(this.componentType);
    });

    this.selectionPayments.changed.subscribe(next => {
      this.checkIfDisabled(next);
    });

  }

  private checkIfDisabled(data) {
    data.added.forEach(payment => {
      if (payment.case_payment_plan.type.slug === 'debt_plan') {
        this.selectionPaymentsDisabled = true;
        if (this.authorizedUsers.includes(this.authUser.id)) {
          this.selectionPaymentsDisabled = false;
        }
      } else {
        this.selectionPaymentsDisabled = false;
      }
    });
  }

  public fetchInstallments(componentType: 'admin' | 'distribution') {
    console.log('fetch installments');
    const data = {
      per_page:        this.paginatorConfig.pageSize,
      page:            this.paginatorConfig.pageIndex + 1,
      case_id:         this.case.id,
      select_all:      1,
      order:           this.sortOrder || 'asc',
      sort_by:         this.sortBy || 'term_date',
      plan_type_slugs: this.installmentsPlanTypeSlugsControl.value ? this.installmentsPlanTypeSlugsControl.value : [],
    };

    const withRelations = [
      'case.client',
      'case.debt_payment_plan',
      'distribution_case_terms',
      //'case.terms',
      'distribution_case_terms.batches',
      'case.payment_status',
      'case_payment_plan.type',
      'case.distribution',
      'child_installments.case_payment_plan.type'
    ];
    const observable    = componentType === 'admin' ?
      this.paymentService.indexCaseInstallments(this.case.id, data, withRelations) :
      this.distributionService.indexInstallments(this.case.uuid, data, withRelations);

    this.isLoading++;
    this.dataSource           = new MatTableDataSource<PaymentTerm>([]);
    this.upcomingInstallments = [];
    observable.pipe(finalize(() => this.isLoading--))
      .subscribe(
        res => this.handleResponse(res),
        error => console.error(error),
      );
    this.refetchInstallments(componentType);
  }

  private refetchInstallments(componentType: 'admin' | 'distribution') {
    if (this.upcomingInstallmentsComponent) {
      this.upcomingInstallmentsComponent.fetchInstallments(componentType);
    }
  }

  public requestPaymentDialog(paymentMethodType: PaymentMethodType, paymentProcessorType: PaymentProcessorType): void {
    const nextTerm       = this.upcomingInstallments.find(t => t.amount > t.amount_paid);
    let maxPayableAmount = 0;
    this.upcomingInstallments.forEach(term => {
      maxPayableAmount += term.amount - term.amount_paid;
    });

    maxPayableAmount = +maxPayableAmount.toFixed(2);

    if (nextTerm) {
      const dialogRef = this.dialog.open(RequestPaymentModalComponent, {
        width:        '50%',
        minHeight:    200,
        disableClose: true,
        autoFocus:    false,
        data:         {
          caseId:                this.case.id,
          paymentMethodType,
          paymentProcessorType,
          amount:                (nextTerm.amount - nextTerm.amount_paid).toFixed(2),
          maxPayableAmount,
          forceDefaultProcessor: this.forceDefaultProcessor,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.success) {
            this.toastr.success(this.translate.instant(
              'CASES.single.request-payment-success'), this.translate.instant('SHARED.success'),
            );
          } else {
            this.toastr.error(this.translate.instant(
              'CASES.single.request-payment-error'), this.translate.instant('SHARED.error'),
            );
          }
        }
      });
    } else {
      this.toastr.error('No installment available');
    }
  }

  public openDialog(relocate = false): void {
    console.log(this.case);
    console.log(this.onlyDebtPlanSelected);
    console.log(this.installmentsPlanTypeSlugsControl.value);
    console.log(this.componentType);

    // const dialogRef = this.dialog.open(RecordPaymentModalComponent, {
    //   width: '80%',
    //   data:  {
    //     case:              this.case,
    //     form:              this.recordForm,
    //     forAdditionalPlan: ! this.onlyDebtPlanSelected,
    //     relocate,
    //   },
    // });
    const dialogRef = this.dialog.open(RecordPaymentModalComponent, {
      width: '80%',
      data:  {
        case:              this.case,
        forAdditionalPlan: ! this.onlyDebtPlanSelected,
        relocate,
        payment_plan_type: this.installmentsPlanTypeSlugsControl.value,
        componentType:     this.componentType
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchInstallments(this.componentType);
        if (relocate) {
          this.toastr.success(this.translate.instant('CASES.single.payment-relocated-success'),
            this.translate.instant('SHARED.success'));
        } else {
          this.toastr.success(this.translate.instant('CASES.single.payment-record-success'),
            this.translate.instant('SHARED.success'));
        }
      }
    });
  }

  public openCardModal(): void {
    const nextTerm       = this.upcomingInstallments.find(t => t.amount > t.amount_paid);
    const chargeAmount   = nextTerm ? (nextTerm.amount - nextTerm.amount_paid).toFixed(2) : 0;
    let maxPayableAmount = 0;
    this.upcomingInstallments.forEach(term => {
      maxPayableAmount += term.amount - term.amount_paid;
    });

    if (nextTerm) {
      const dialogRef = this.dialog.open(AdminPaymentHandlerComponent, {
        width:        '60%',
        minHeight:    200,
        disableClose: false,
        panelClass:   ['custom-mat-dialog', 'scrollable-mat-dialog'],
        autoFocus:    false,
        data:         {
          caseId:          this.case.id,
          clientRole:      'client',
          type:            'moto',
          amount:          chargeAmount,
          editableAmount:  true,
          maxPayableAmount,
          paymentPlanType: this.forceDefaultProcessor ? 'additional_plans' : 'debt_plan',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.reFetch) {
          this.fetchInstallments(this.componentType);
          this.displayDistributionWarningModal();
        }
      });
    }
  }

  public getDistributionSchedule(term, previousDistributionDate = null) {

    if (term.type === "phase_one") {
      return null;
    }

    const currentDate = new Date();
    const termDate    = new Date(term.term_date);
    const datePaid    = term.date_paid ? new Date(term.date_paid) : null;

    const currentNextMont = new Date();
    currentNextMont.setMonth(currentNextMont.getMonth() + 1);

    // Set distribution to the 15th of the month following termDate
    let distributionDate = new Date(termDate.getFullYear(), termDate.getMonth() + 1, 15);

    // If there's a previous distribution date (due to an unpaid installment), use it
    if (previousDistributionDate) {
      const previousDate = new Date(previousDistributionDate);

      // Only update if the previous distribution date is not in the same month
      if (previousDate.getMonth() !== termDate.getMonth()) {
        distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() + 1, 15);

        // If no payment is made, return the calculated distribution date
        if ( ! datePaid) {
          return distributionDate;
        }

        // If a payment is made, adjust the distribution based on the payment date
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() + 1, 15);
      }
    }

    // Handle the case where date_paid is between the 1st and 5th of the next month
    const nextMonth        = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 1);
    const fifthOfNextMonth = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 7); //requested change to 7 temporarly

    // Payment after the 5th of the next month -> shift distribution date one month further
    if (datePaid && datePaid > fifthOfNextMonth) {
      distributionDate = new Date(distributionDate.getFullYear(), distributionDate.getMonth() + 1, 15);
      return distributionDate;
    }

    // Payment is made before or on the 5th of the next month -> keep the next month's 15th
    if (datePaid && datePaid >= nextMonth && datePaid <= fifthOfNextMonth) {
      return distributionDate;
    }

    // No payment made, return the distribution date based on the current date or previous date
    if ( ! datePaid) {
      distributionDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 15);
      if (previousDistributionDate) {
        const previousDate = new Date(previousDistributionDate);
        if (previousDate.getTime() >= distributionDate.getTime()) {
          distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() + 1, 15);
        }
      }
      return distributionDate;
    }

    //when previous is larger than current and payment is done between 1-5 next month
    if (datePaid && previousDistributionDate && previousDistributionDate > currentNextMont) {
      //const previousDate = new Date(previousDistributionDate);
      const fifthOfNextMonth = new Date(datePaid.getFullYear(), datePaid.getMonth(), 7); //requested change to 7 temporarly

      if (datePaid <= fifthOfNextMonth) {
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth(), 15);
      } else {
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() + 1, 15);
      }
    }

    return distributionDate;
  }

  public handleResponse(response: LaravelResourceResponse) {
    //  Get total amount of paid terms and total amount to pay
    this.filteredInstallmentsBalance.totalToPay       = 0;
    this.filteredInstallmentsBalance.totalPaid        = 0;
    this.filteredInstallmentsBalance.totalPaidCounter = 0;
    this.filteredInstallmentsBalance.totalDistributed = 0;

    let totalTermDistribution: number = 0;
    let totalTermDisburse: number     = 0;
    let term_distributed_at: Date     = null;
    let term_disbursed_at: Date       = null;
    let previousDistributionDate      = null;


    response.data.forEach(term => {
      totalTermDistribution = 0;
      totalTermDisburse     = 0;
      term_distributed_at   = null;
      term_disbursed_at     = null;

      this.filteredInstallmentsBalance.totalToPay += term.amount;
      this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
      this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;

      term.distribution_case_terms.forEach(dist => {

        const isTermInDistribution = term.case.distribution.some((caseDist: any) =>
          caseDist.distribution_batch_id === dist.batches.id
        );

        if ( ! isTermInDistribution) {
          console.log(`Batch ID ${dist.batches.id} is not in term.case.distribution`);
          return;
        }

        this.filteredInstallmentsBalance.totalDistributed += dist.amount_distributed;
        totalTermDistribution += dist.amount_distributed;
        if (dist.disbursed) {
          totalTermDisburse += dist.amount_distributed;
        }
        if (term.id === dist.term_id &&
          dist.distributed_at != null &&
          dist.distributed_at !== undefined
          && dist.distributed_at !== '') {
          term_distributed_at = dist.distributed_at;
        }
        if (term.id === dist.term_id &&
          dist.disbursed_at != null &&
          dist.disbursed_at !== undefined
          && dist.disbursed_at !== '') {
          term_disbursed_at = dist.disbursed_at;
        }
      });
      term.total_distributed_amount = totalTermDistribution;
      term.total_disbursed_amount   = totalTermDisburse;
      term.distribution_schedule    = this.getDistributionSchedule(term, previousDistributionDate);
      previousDistributionDate      = term.distribution_schedule;
      term.distributed_at           = term_distributed_at;
      term.disbursed_at             = term_disbursed_at;
      term.offer_to_creditors_total = Number(this.case.expense.offer_to_creditors_total);
      term.distribution_fee         = Number(this.case.expense.distribution_fee);

    });

    const onlyUnpaid = response.data.filter(obj => obj.amount !== obj.amount_paid);

    this.totalResults         = response.data.total;
    this.upcomingInstallments = response.data;
    this.unpaidInstallments   = onlyUnpaid;

    const installments = response.data.map(installment => {
      return {
        ...installment,
        child_installments_source: new MatTableDataSource<PaymentTerm>(installment.child_installments)
      };
    });
  }

  public getPercent(paid, amount) {
    if ((paid / amount) * 100) {
      return ((paid / amount) * 100).toFixed(2);
    } else {
      return 0;
    }
  }

  deleteAndRebuild(rebuildType: string = 'full_from_start') {
    this.isLoading++;
    if (this.case.product.group_slug === 'ds' || this.case.product.group_slug === 'refinance') {
      this.paymentService.rebuildInstallmentPlan(this.case.id, rebuildType)  //  Rebuild installments
        .pipe(finalize(() => this.isLoading--))
        .subscribe(
          res => {
            this.fetchInstallments(this.componentType);
            this.toastr.success(this.translate.instant('CASES.single.rebuild-plan-note-success'));
          },
          error => {
            this.toastr.error(error.message, this.translate.instant('SHARED.error'));
          },
        );
    } else {
      this.paymentService.deleteAllPayments(this.case.id) //  Delete all installments
        .subscribe(
          value => {
            this.paymentService.rebuildInstallmentPlan(this.case.id, rebuildType)  //  Rebuild installments
              .pipe(finalize(() => this.isLoading--))
              .subscribe(
                res => {
                  this.fetchInstallments(this.componentType);
                  this.toastr.success(this.translate.instant('CASES.single.rebuild-plan-note-success'));
                },
                error => {
                  this.toastr.error(error.message, this.translate.instant('SHARED.error'));
                },
              );
          },
          error => this.toastr.error(error.message, this.translate.instant('SHARED.error')),
        );
    }
  }

  rebuild(rebuildType: string = 'only_unpaid') {
    this.isLoading++;
    this.paymentService.rebuildInstallmentPlan(this.case.id, rebuildType)  //  Rebuild installments
      .pipe(finalize(() => this.isLoading--))
      .subscribe(
        res => {
          this.fetchInstallments(this.componentType);
          this.toastr.success(this.translate.instant('CASES.single.rebuild-plan-note-success'));
        },
        error => {
          this.toastr.error(error.message, this.translate.instant('SHARED.error'));
        },
      );
  }

  rebuildManual(data) {
    this.isLoading++;
    this.paymentService.rebuildInstallmentPlanManual(data)  //  Rebuild installments
      .pipe(finalize(() => this.isLoading--))
      .subscribe(
        res => {
          this.fetchInstallments(this.componentType);
          this.toastr.success(this.translate.instant('CASES.single.rebuild-plan-note-success'));
        },
        error => {
          this.toastr.error(error.message, this.translate.instant('SHARED.error'));
        },
      );
  }

  public rebuildInstallmentPlanModal() {
    if (this.case.product.group_slug === 'ds' || this.case.product.group_slug === 'refinance') {
      const dialogRef = this.dialog.open(RebuildPaymentPlanV2Component, {
        width: '60%',
        data:  {
          case: this.case,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if ( ! result.dismissed) {
          this.fetchInstallments(this.componentType);
        }
      });
    } else {
      const dialogRef = this.dialog.open(RebuildPaymentPlanComponent, {
        width: '60%',
        data:  {
          case:             this.case,
          terms:            this.upcomingInstallments,
          deleteAndRebuild: (rebuildType: string) => this.deleteAndRebuild(rebuildType),
          rebuild:          () => this.rebuild(),
          rebuildManual:    (data) => this.rebuildManual(data),
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        // this.fetchPayments();
      });
    }
  }

  public transferFeesModal() {
    const dialogRef = this.dialog.open(TransferFeesComponent, {
      width: '350px',
      data:  {
        case: this.case,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.fetchInstallments(this.componentType);
    });
  }

  public openPaymentPlanGenerationModal() {
    const dialogRef = this.dialog.open(CasePaymentPlanGeneratorComponent, {
      width: '60%',
      data:  {
        case: this.case,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.fetchInstallments(this.componentType);
    });
  }

  private fetchPaymentMethods(componentType: 'admin' | 'distribution'): void {
    if (componentType === 'distribution') {
      this.paymentMethods = [];
      return;
    }
    this.isLoading++;
    this.paymentMethodService.index({}, ['billing_bank_accounts']).pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
        this.paymentMethods = result.data;
        console.log(this.paymentMethods);
      });
  }

  private fetchPaymentPlanTypes(componentType: 'distribution' | 'admin') {
    console.log('fetch payment plan types');
    this.isLoading++;
    this.paymentPlanTypeService.index().pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
        let data              = result.data.filter(planType => ! ['claim_fee', 'asnef_fee', 'annual_review_fee'].includes(planType.slug));
        this.paymentPlanTypes = componentType === 'admin' ?
          data :
          data.filter(planType => planType.default === true);
        this.fetchPaymentMethods(this.componentType);
      });
  }

  displayDistributionWarningModal(): void {
    Swal.fire({
      text:               this.translate.instant('DISTRIBUTION.modals.confirm-payment'),
      icon:               'warning',
      showCancelButton:   false,
      confirmButtonText:  'OK',
      confirmButtonColor: '#4267b2',
    });
  }

  public updateComponentType(type: 'distribution' | 'admin') {
    this.componentType = type;
    this.fetchInstallments(type);
  }

  public isPhaseTwo() {
    const phaseTwoStatusIds = [335, 507];
    //const enabledRoles = environment.ALLOW_CASES_ROLES_IDS;

    if (
      this.userIsAMami() &&
      this.case.status_id === phaseTwoStatusIds[1] &&
      this.case.distribution_case_terms.length > 0) {
      return true;
    }
    return this.case.status_id === phaseTwoStatusIds[0];
  }

  public userIsAMami(): boolean {
    return environment.DISTRIBUTION_USER_IDS.includes(this.authUser.id);
  }

  public viewCalculations() {
    //months pending to pay
    let totalMonthsToPay: number = this.case.terms.length;
    let fee                      = this.case.expense.distribution_fee;
    let feesPaid                 = 0;
    let totalMonthsFullyPaid     = 0;
    let totalDebtAmount          = 0;
    let totalFinalPayments       = 0;
    let totalCreditorsOffer      = 0;
    this.case.terms.forEach((item, index) => {

      //console.log(`Item at index ${index}:`, item);
      if (item.amount_paid > 0) {
        totalMonthsToPay--;
        feesPaid += item.amount_paid;
      }
      if (item.amount_paid != null && item.amount_paid > this.case.expense.distribution_fee) {
        //console.log("Fully paid");
        //console.log(item.amount_paid);
        //console.log(fee);
        totalMonthsFullyPaid++;
      }
    });

    this.case.creditors.forEach((item, index) => {
      if (item.pivot.debt_amount > 0) {
        totalDebtAmount += Number(item.pivot.debt_amount);
      }

      //Ehem
      if (item.pivot.offer_to_creditor > 0) {
        totalCreditorsOffer += item.pivot.offer_to_creditor;
      }

      if (item.pivot.final_payment > 0) {
        totalFinalPayments += item.pivot.final_payment;
      }
    });

    return {
      DmTotalMonthsPending: totalMonthsToPay,
      DMfeePaid:            feesPaid,
      DMMonthsFeeFullyPaid: totalMonthsFullyPaid,
      DMTotalDebtAmount:    totalDebtAmount,
      totalCreditorsOffer,
      totalFinalPayments //,
      //DMbalance: balance
    };
  }

  public downloadClientInstallment(): void {
    const data        = {
      document_type_slug: 'client-installment-list'
    };
    this.isSubmitting = true;
    this.caseDocumentService.generateDocument(this.case.id, data)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe(result => {
        if (result.type === 4) {
          const fileName = 'client-installment-list_' + DateTime.local().toFormat('yyyy-LL-dd_HH-mm') + '.' + 'pdf';
          saveAs(result.body, fileName);
          this.toastr.success('Downloaded document');
        }
      }, err => {
        this.toastr.error('Failed to generate document');
      });
  }

  public sendPaymentPlan(): void {
    this.caseDocumentService.sendClientInstallmentList(this.case.id).subscribe(res => {
      this.toastr.success(this.translate.instant('SHARED.success'));
    }, err => {
      this.toastr.error(this.translate.instant('SHARED.went-wrong'));
    });
  }

  public isElementRestricted() {
    if (this.authUser.id === 1) {
      return true;
    }
    const enabledRoles         = environment.ALLOW_CASES_ROLES_IDS;
    const enabledStatusId      = environment.BLOCK_CASES_STATUS_IDS;
    const enabledDepartmentsId = environment.ALLOW_CASES_DEPARTMENTS_IDS;

    const isDepartmentAllowed = this.authUser.departments.some(department =>
      enabledDepartmentsId.includes(department.id)
    );

    if (
      ! enabledStatusId.includes(this.case.status_id) ||
      enabledRoles.includes(this.authUser.role_id) ||
      isDepartmentAllowed
    ) {
      return true;
    }
    return false;
  }

  public selectionPaymentsDisabledChanged(event) {
    console.log(event);
    this.selectionPaymentsDisabled = event;
  }

  tabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.installmentListActive = true;
      this.fetchInstallments(this.componentType)
    } else {
      this.installmentListActive = false;
    }
  }

  private fetchInstallmentFees(paymentPlanType: 'debt_plan_fee' | 'negotiation_fee' | 'management_fee'): void {
    const data = {
      case_id:                this.case.id,
      payment_plan_type_slug: paymentPlanType,
    };
    this.isLoading++;
    this.paymentService.getInstallmentFees(this.case.id, data, [])
      .pipe(finalize(() => this.isLoading--))
      .subscribe(
        (result: LaravelResourceResponse<Array<PaymentTerm>>) => {
          paymentPlanType === 'negotiation_fee' ? this.negotiationFeeInstallments = result.data :
            (paymentPlanType === 'management_fee' ? this.managementFeeInstallments = result.data :
              this.debtPlanFeeInstallments = result.data)
          if (paymentPlanType === 'debt_plan_fee') {
            this.totalAmountPaidDebtPlan = this.debtPlanFeeInstallments.reduce((sum, item) => {
              return sum + (item.amount_paid || 0);
            }, 0);
            this.settlementBalance       = this.case?.settlement_paid - this.totalAmountPaidDebtPlan;
          } else if (paymentPlanType === 'management_fee') {
            this.totalAmountPaidManagement = this.managementFeeInstallments.reduce((sum, item) => {
              return sum + (item.amount_paid || 0);
            }, 0);
            this.totalDebtAmountManagement = this.managementFeeInstallments.reduce((sum, item) => {
              return sum + (item.amount || 0);
            }, 0);
            this.managementBalance         = this.totalDebtAmountManagement - this.totalAmountPaidManagement;
          } else if (paymentPlanType === 'negotiation_fee') {
            this.totalAmountPaidNegotiation = this.negotiationFeeInstallments.reduce((sum, item) => {
              return sum + (item.amount_paid || 0);
            }, 0);
            this.totalDebtAmountNegotiation = this.negotiationFeeInstallments.reduce((sum, item) => {
              return sum + (item.amount || 0);
            }, 0);
            this.negotiationBalance         = this.totalDebtAmountNegotiation - this.totalAmountPaidNegotiation;
          }
        },
        err => console.error(err),
      );
  }

  private getPaymentPlanTypeGroups(): Array<AppSelectOption> {
    return [
      {label: this.translate.instant('PAYMENTS.payment_plan_group.options.debt_plan'), value: 'debt_plan'},
      {label: this.translate.instant('PAYMENTS.payment_plan_group.options.additional_plans'), value: 'additional_plans'}
    ];
  }

  public planTypeGroupsUpdated(productGroupSlugs: Array<'debt_plan' | 'additional_plans'>) {
    console.log(productGroupSlugs);

    const paymentPlanSlugs = [];
    productGroupSlugs.forEach(groupSlug => {
      this.paymentPlanTypes.forEach(product => {
        if (groupSlug === 'debt_plan' && product.slug === 'debt_plan') {
          paymentPlanSlugs.push(product.slug);
        } else if (groupSlug === 'additional_plans' && product.slug !== 'debt_plan') {
          paymentPlanSlugs.push(product.slug);
        }
      });
    });
    this.installmentsPlanTypeSlugsControl.patchValue(paymentPlanSlugs);
    this.onlyDebtPlanSelected      = productGroupSlugs.includes('debt_plan') && productGroupSlugs.length === 1;
    this.selectionPaymentsDisabled = !! (productGroupSlugs.includes('debt_plan') || productGroupSlugs.length === 0);
    this.forceDefaultProcessor     = productGroupSlugs?.length ? ! productGroupSlugs.includes('debt_plan') : false;
  }

  installmentPlanTypeGroupChanged($event: any): void {
    this.installmentsPlanTypeGroupsControl.patchValue($event);
  }
}
